@if (mode() === "ADD" || mode() === "RENAME") {
	<div class="text">
		<ng-content></ng-content>
		@if (!entry.secondLineTranslate) {
			<h6>{{ entry.secondLine }}</h6>
		}
		@if (entry.secondLineTranslate) {
			<h6 translate="{{ entry.secondLineTranslate }}"></h6>
		}
	</div>
}
@if (!(mode() === "ADD" || mode() === "RENAME")) {
	<div class="text">
		@if (entry.labelTranslate) {
			<h3 [ngClass]="entry.labelClasses" [translate]="entry.labelTranslate"></h3>
		}
		@if (!entry.labelTranslate) {
			<h3 [ngClass]="entry.labelClasses">{{ entry.label }}</h3>
		}
		@if (!entry.secondLineTranslate) {
			<h6>{{ entry.secondLine }}</h6>
		}
		@if (entry.secondLineTranslate) {
			<h6 translate="{{ entry.secondLineTranslate }}"></h6>
		}
		@if (originalHasChangeMarker) {
			<div class="info change-marker">
				<div>
					@if (entry.original.changeMarker.changed) {
						<span class="badge changed-badge" translate="process.compare.changed"></span>
					}
					@if (entry.original.changeMarker.added) {
						<span class="badge added-badge" translate="process.compare.added"></span>
					}
					@if (entry.original.changeMarker.deleted) {
						<span class="badge deleted-badge" translate="process.compare.deleted"></span>
					}
				</div>
				<div>
					@if (entry.original.changeMarker.subelements > 0) {
						<i class="ico ico-exclamation-mark subelements"></i>
					}
				</div>
			</div>
		}
	</div>
	<ng-container />
}
